"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class Cluster {
    constructor(idx) {
        this.name = '';
        this.samples = [];
        this.idx = idx;
    }
    get default_name() {
        return 'Cluster ' + (this.idx + 1);
    }
    get name_or_default() {
        return this.name || this.default_name;
    }
    get hasWarnings() {
        const upperThreshold = 3;
        const hasBeCrop1 = this.samples.some((sample) => (0, lodash_1.isNull)(sample.becrop_report_shi));
        const hasBeCrop2 = this.samples.some((sample) => !(0, lodash_1.isNull)(sample.becrop_report_shi));
        const tooMany = () => this.samples.length > upperThreshold;
        return (tooMany || (hasBeCrop1 && hasBeCrop2));
    }
    add(sample) {
        this.samples.push(sample);
    }
    rm(sample) {
        for (let i = 0; i < this.samples.length; i++) {
            if (this.samples[i].id == sample.id) {
                this.samples.splice(i, 1);
                break;
            }
        }
    }
}
exports.default = Cluster;
